export default "__VITE_ASSET__Bi54XQxG__"